import { Wrapper } from '@american-autonomy/ag-ui';

import { DEFAULT_STATUS, SELECTED_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const TimelineItem: FunctionComponent<Props> = ({
    children,
    className = '',
    isSelected = false,
    onClick,
    status = DEFAULT_STATUS,
    testId = TEST_ID
}) => {
    const clickableClass = onClick ? styles.clickable : '';
    const selectedClass = isSelected ? styles.selected : '';

    return (
        <Wrapper
            className={`${styles.timelineItem} ${clickableClass} ${selectedClass} ${className}`}
            onClick={onClick}
            testId={testId}>
            {isSelected ? (
                <Wrapper className={styles.selectedMarker} testId={SELECTED_TEST_ID} />
            ) : null}

            <Wrapper className={`${styles.dot} ${styles[status]}`} />

            <Wrapper className={styles.content}>{children}</Wrapper>
        </Wrapper>
    );
};

export default TimelineItem;
